export default "__VITE_ASSET__DdsLuWC5__"